class Account {
  id;

  name;

  email;

  domain;

  userType;

  updateFromJson(json) {
    this.id = json.id;
    this.name = json.name;
    this.email = json.email;
    this.domain = json.domain;
    this.userType = json.userType;
  }
}

export default Account;
